import styled from 'styled-components';

export const List = styled.div`
	max-height: 400px;
	overflow-y: auto;
	margin: 8px 0;
	padding-right: 22px;
`;

export const VersionRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 8px 12px;
	border-bottom: 1px solid ${({ theme }) => theme.gray[200]};

	&:last-child {
		border-bottom: none;
	}
`;

export const RowLeft = styled.div`
	display: flex;
	align-items: baseline;
	gap: 8px;
`;

export const VersionLabel = styled.span`
	font-size: 14px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[1000]};
`;

export const RelativeDate = styled.span`
	font-size: 12px;
	color: ${({ theme }) => theme.gray[600]};
`;

export const RowRight = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`;

export const ActionLink = styled.button`
	font-size: 12px;
	color: ${({ theme }) => theme.gray[400]};
	background: none;
	border: none;
	padding: 0;
	font-family: inherit;

	&:hover {
		color: ${({ theme }) => theme.gray[1000]};
	}
`;
